import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface PesvRequisitosDesplazamientosPayload {
  desplazamiento_id: number;
  requisito: string;
  cumple?: number;
  observaciones?: string | null;
}

/**
 * 🔹 Entidad
 */
export interface PesvRequisitosDesplazamientos {
  id?: number;
  desplazamiento_id: number;
  requisito: string;
  cumple: number;
  observaciones?: string | null;
  estado?: number;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface PesvRequisitosDesplazamientosResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class PesvRequisitosDesplazamientosService {
  private readonly apiUrl =
    `${environment.apiUrl}/api/pesv_requisitos_desplazamientos`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todos los requisitos
   */
  getAll(): Observable<PesvRequisitosDesplazamientos[]> {
    return this.http.get<PesvRequisitosDesplazamientos[]>(
      this.apiUrl,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Obtener requisito por ID
   */
  getById(
    id: number
  ): Observable<PesvRequisitosDesplazamientos> {
    return this.http.get<PesvRequisitosDesplazamientos>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Obtener requisitos por desplazamiento
   */
  getByDesplazamiento(
    desplazamientoId: number
  ): Observable<PesvRequisitosDesplazamientos[]> {
    return this.http.get<PesvRequisitosDesplazamientos[]>(
      `${this.apiUrl}/desplazamiento/${desplazamientoId}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear requisito
   */
  create(
    payload: PesvRequisitosDesplazamientosPayload
  ): Observable<PesvRequisitosDesplazamientosResponse> {
    return this.http.post<PesvRequisitosDesplazamientosResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar requisito
   */
  update(
    id: number,
    payload: Partial<PesvRequisitosDesplazamientosPayload>
  ): Observable<PesvRequisitosDesplazamientosResponse> {
    return this.http.put<PesvRequisitosDesplazamientosResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar requisito
   */
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Inactivar requisito
   */
  inactivar(id: number): Observable<PesvRequisitosDesplazamientosResponse> {
    return this.http.put<PesvRequisitosDesplazamientosResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Activar requisito
   */
  activar(id: number): Observable<PesvRequisitosDesplazamientosResponse> {
    return this.http.put<PesvRequisitosDesplazamientosResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}